import defaultSettings from '../settings.json';
export interface GlobalState {
  settings?: typeof defaultSettings;
  userInfo?: {
    name?: string;
    avatar?: string;
    job?: string;
    organization?: string;
    location?: string;
    email?: string;
    permissions: Record<string, string[]>;
  };
  authInfo?: {
    access_token:       string;
    token_type:         string;
    expires_in:         number;
    name:               string;
    en_name:            string;
    avatar_url:         string;
    avatar_thumb:       string;
    avatar_middle:      string;
    avatar_big:         string;
    open_id:            string;
    union_id:           string;
    email:              string;
    enterprise_email:   string;
    user_id:            string;
    tenant_key:         string;
    refresh_expires_in: number;
    refresh_token:      string;
    can_create:         boolean;
  }
}

const initialState: GlobalState = {
  settings: defaultSettings,
  userInfo: {
    permissions: {},
  },
  authInfo: {
    access_token:       '',
    token_type:         '',
    expires_in:         0,
    name:               '',
    en_name:            '',
    avatar_url:         '',
    avatar_thumb:       '',
    avatar_middle:      '',
    avatar_big:         '',
    open_id:            '',
    union_id:           '',
    email:              '',
    enterprise_email:   '',
    user_id:            '',
    tenant_key:         '',
    refresh_expires_in: 0,
    refresh_token:      '',
    can_create:         false,
  }
};

export default function store(state = initialState, action) {
  switch (action.type) {
    case 'update-settings': {
      const { settings } = action.payload;
      return {
        ...state,
        settings,
      };
    }
    case 'update-userInfo': {
      const { userInfo = initialState.userInfo, userLoading } = action.payload;
      return {
        ...state,
        userLoading,
        userInfo,
      };
    }
    case 'update-authInfo': {
      const { authInfo = initialState.authInfo } = action.payload;
      return {
        ...state,
        authInfo,
      }
    }
    default:
      return state;
  }
}
